import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Form } from "antd";
import Button from "@/common/elements/Button";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import useDialog from "@/hooks/useDialog";
import { useSelector } from "react-redux";

const JailIncidentInvolvedReportInformation = ({
  data,
  disciplineRequired = "",
  isFieldEnable,
}) => {
  const { showDialog } = useDialog();

  const onHandleViewComment = () => {
    showDialog("info", {
      content: data?.getFieldValue("hearingComments") || "No comment available",
      confirmButtonText: "Ok",
    });
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Report Information</span>
      </StyledSectionHeading>

      <StyledGridRow gutter={16}>
        <StyledGridCol lg={6}>
          <FormItem
            label="Involvement Type"
            name="jailIncidentsInvolvementType"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              options={getOptionsFromRefList("JailIncidentsInvolvementType")}
              disabled={!isFieldEnable}
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem label="Action Taken" name="disciplineRequired">
            <Select
              options={getOptionsFromRefList("Discipline_Required")}
              disabled={!isFieldEnable}
            />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>

      {!isNonEmptyVariable(disciplineRequired) && (
        <>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={7}>
              <FormItem label="Start Date/Time" name="startDateTime">
                <CommonDatePicker
                  format="MM/DD/YYYY HH:mm"
                  disabled={!isFieldEnable}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={7}>
              <FormItem label="Hearing Due Date/Time" name="hearingDueDateTime">
                <CommonDatePicker
                  format="MM/DD/YYYY HH:mm"
                  disabled={!isFieldEnable}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>

          <StyledGridRow gutter={16}>
            <StyledGridCol lg={7}>
              <FormItem label="Hearing Date/Time" name="hearingDateTime">
                <CommonDatePicker
                  format="MM/DD/YYYY HH:mm"
                  disabled={!isFieldEnable}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem label="Hearing Officer" name="hearingOfficerStaffID">
                <Select
                  options={getOptionsFromRefList("", true, true, true)}
                  disabled={!isFieldEnable}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem label="Review Officer" name="reviewOfficerStaffID">
                <Select
                  options={getOptionsFromRefList("", true, true, true)}
                  disabled={!isFieldEnable}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={5}>
              <FormItem label="Results" name="jailIncidentsResults">
                <Select
                  options={getOptionsFromRefList("JailIncidentsResults")}
                  disabled={!isFieldEnable}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol xs={24} lg={24}>
              <FormItem label="Comments" name="hearingComments">
                <TextField
                  inputType="textarea"
                  rows="3"
                  disabled={!isFieldEnable}
                />
              </FormItem>
              <Button
                type="primary"
                color="primary"
                onClick={onHandleViewComment}
              >
                View Comments
              </Button>
            </StyledGridCol>
          </StyledGridRow>
        </>
      )}
    </>
  );
};

export default JailIncidentInvolvedReportInformation;
